module.exports = __webpack_public_path__ + "img/Quiz-background.dc90e743.png";